import { cn } from '@talentmesh/ui/lib/utils';
import { PercentileLevel } from '@talentmesh/utils';
import percentileInTextColors from '@/lib/utils';

export interface ColoredScoreCellProps {
    level?: PercentileLevel | null;
    score?: number | null;
}

const ScoreCell = ({ level, score }: ColoredScoreCellProps) => {
    return (
        <p
            className={cn(
                'text-percentile* mx-auto block text-center text-sm font-bold transition-colors duration-150',
                level ? percentileInTextColors[level] : '',
            )}
        >
            {score ?? '-'}
        </p>
    );
};

export default ScoreCell;
